// import data from './data/data.json';

export default function (props) {
  const { initialWidth, initialHeight, isMobile } = props;

  const margins = {
	    top: 20,
	    right: 25,
	    bottom: 30,
	    left: 50,
  };

  const width = initialWidth - margins.right - margins.left;
  const height = initialHeight - margins.top - margins.bottom;

  return {
    height,
    initialWidth,
    initialHeight,
    margins,
    width,
  };
}
